<template>
  <div class="lists">
      <ul>
          <li v-for="(item,index) in list" :key="index">
              <div>
                  <template v-if="item.ExCMPlogo">
                      <img :src="item.ExCMPlogo">
                  </template>
                  <template v-else>
                      <img src="../assets/images/company.png" >
                  </template>
              </div>
              <div>
                  <p>{{item.ExCMPName}}</p>
                  <p><span>{{item.ExDate}}</span><br><span>{{item.ExSchName}}</span></p>
              </div>
              <div>
                  <button @click="applyItem(item.ExPKID,item.ExStatus)" :class="{isOver:item.ExStatus=='已结束'}">{{item.ExStatus?item.ExStatus:"报名"}}</button>
              </div>
          </li>
      </ul>
      <Dialog :dialog_toggle.sync="dialog" width="85%">
        <template v-slot:title>
          <div class="mb-dialog-title"><img src="../assets/images/logo.png"><span>快速报名</span></div>
        </template>
        <ApplyForm :select_expkid="expkid" @close="e=>dialog=e"></ApplyForm>
      </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/JobDialog.vue"
import ApplyForm from "@/components/ApplyForm.vue"
export default {
    name:"Lists",
    props:["list"],
    components:{Dialog,ApplyForm},
}
</script>

<style scoped lang="less">
*{
    -webkit-overflow-scrolling: touch;
}
.isOver{
    background: #ccc !important;
}
.lists{
    text-align: left;
    -webkit-overflow-scrolling: touch;
    button{
        border: none;
        outline: none;
    }
    &>ul>li{
        display: flex;
        padding: 0.1rem 0;
        position: relative;
        
        &>div{
            display: flex;
            img{
                width: 100%;
                height: 100%;
                transform-origin: center;
                transform: scale(0.75);
            }
        }
        &>div:nth-child(2){
            flex: 1 1;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            &>p:first-child{
                font-size: 0.96rem;
                font-weight: 600;
            }
            &>p:nth-child(2){
                margin-top: 0.3rem;
                font-size: 0.8rem;
                color: #777777;
            }
        }
        &>div:first-child{
            width: 5rem;
            justify-content: center;
            align-items: center;
        }
        &>div:last-child{
            width: 5rem;
            justify-content: center;
            align-items: center;
            button{
                width: 3.5rem;
                padding: 0.3rem 0;
                background: #ff6000;
                color: #fff;
                border-radius: 3px;
            }
        }
    }
    &>ul>li:not(:last-child)::before{
        content: "";
        position: absolute;
        bottom: 0;left: 0.9rem;right: 0.9rem;
        background: #ccc;
        height: 1px;
        transform: scaleY(0.5);
    }
}
.mb-dialog-title{
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #ff8421;
  img{
    width: 75px;
    height: 28px;
    margin-right: 8px;
  }
}


</style>